// import { Card, Drawer } from 'antd'
import { ArrowRightOutlined } from '@ant-design/icons'
import React from 'react'
import './support-card.scss'

interface SupportCardProps {
  icon: any
  title: string
  onClick: (type?: any) => void
  formType?: string
}

const SupportCard: React.FC<SupportCardProps> = ({
  icon: Icon,
  title,
  onClick,
  formType,
}) => {
  return (
    <button
      className={`flex flex-col gap-6 w-full cursor-pointer text-white border-solid border-transparent border-1 hover:border-solid hover:border-focus-blue hover:border-1 active:border-solid active:border-focus-blue active:border-1 selected:border-solid selected:border-focus-blue selected:border-1 drop-shadow-md rounded-xl font-barlow text-base md:text-xl font-medium h-full
      ${
        formType?.toLocaleLowerCase() === 'self'
          ? 'green-angular-gradient'
          : 'blue-angular-gradient'
      }`}
      onClick={() => onClick(formType)}
    >
      <div className="shining-card p-5 h-full">
        {/* https://codepen.io/fishtoyo/pen/VYQVQx - Added metal shining effect from here */}
        <div className="flex flex-row w-full justify-between">
          <div>
            <Icon className="text-3xl" />
          </div>
          <div>
            <ArrowRightOutlined className="text-2xl" />
          </div>
        </div>
        <div className="select-none text-start">{title}</div>
      </div>
    </button>
  )
}

export default SupportCard
